import { setShareInfo } from "@jmdd/jmdd-full-share";

import {loadScript} from '../utils/tool'

export const setjDShare = (sharingTitle, sharingContent) => {
    let sharingUrl =
      `${document.location.protocol}//${window.location.host}${window.location.pathname}${document.location.hash}`;
    let sharingImgUrl = window.location.protocol
        + '//img11.360buyimg.com/cms/jfs/t2560/250/498791371/29862/932ee2a7/5653e2f8N0bb9e689.jpg';

    setShareInfo({
        url: sharingUrl,
        img: sharingImgUrl,
        title: sharingTitle,
        desc: sharingContent,
        timeline: sharingContent,
    });
}

export const setShare = (sharingTitle, sharingContent, sharingUrl, sharingImgUrl) => {
    try {
        window.jdShare.setShareInfo({
            title: sharingTitle,
            content: sharingContent,
            url: sharingUrl,
            img: sharingImgUrl,
            channel: '',
            callback: null,
        });
    } catch (error) {
        console.log(error);
    }
};

export const getEnv = () => {
    var _ua = navigator.userAgent.toLowerCase();
    if(!/mobile|android/.test(_ua)){
        return 'pc';
    }else{
        if(/micromessenger(\/[\d\.]+)*/.test(_ua)){
            return 'weixin';
        }else if(/qq\/(\/[\d\.]+)*/.test(_ua) || /qzone\//.test(_ua)){
            return 'qq';
        } else if(/jdapp/.test(_ua)){
            return 'jdapp';
        } else {
            return 'h5';
        }
    }
}

function shareTimeLine(options) {
    window.WeixinJSBridge.invoke('shareTimeline', options, function (res) {
    });
}

function shareFriend(options) {
    // alert(JSON.stringify(options))
    window.WeixinJSBridge.invoke('sendAppMessage', options, function (res) {
    });
}

export const secondShasreInWX = (title, desc, img) => {
    const currentEnv = getEnv();
    if (currentEnv == "weixin" || currentEnv == "qq") {
            try {
                if (PaimaiUtils && PaimaiUtils.WxShare && typeof PaimaiUtils.WxShare.setShareInfo === 'function') {
                PaimaiUtils.WxShare.setShareInfo({ 
                        title: title || '京东资产交易',
                        content: desc || '我在京东资产交易发现了个不错的拍品，快来看看吧！',
                        url: window.location.href,
                        img: img || 'https://img11.360buyimg.com/cms/jfs/t2560/250/498791371/29862/932ee2a7/5653e2f8N0bb9e689.jpg'
                })
                }
        } catch (err) {
                console.log(err)
        }
    }
}

// export const secondShasreInWX = (sharingTitle, sharingContent, sharingImgUrl) => {
//     // 分享二次分享设置
//     let currentEnv = getEnv();
//     if (currentEnv == "weixin" || currentEnv == "qq") {
//         try {
//             document.addEventListener('WeixinJSBridgeReady', function () {
//                 window.WeixinJSBridge.on('menu:share:appmessage', function () {
//                     shareFriend({
//                         appid: '',  // 可以不设置 但必须存在这属性
//                         img_url: sharingImgUrl,  // 分享图片的路径
//                         img_width: '120',
//                         img_height: '120',
//                         link: `${document.location.protocol}//${window.location.host}${window.location.pathname}${document.location.hash}`,  // 分享的链接
//                         desc: sharingContent,
//                         title: sharingTitle,  // 分享的标题
//                     });
//                 });
//                 window.WeixinJSBridge.on('menu:share:timeline', function () {
//                     shareTimeLine({
//                         appid: '',  // 可以不设置 但必须存在这属性
//                         img_url: sharingImgUrl,  // 分享图片的路径
//                         img_width: '120',
//                         img_height: '120',
//                         link: `${document.location.protocol}//${window.location.host}${window.location.pathname}${document.location.hash}`,  // 分享的链接
//                         desc: sharingContent,
//                         title: sharingTitle,  // 分享的标题
//                     });
//                 });
//             }, false);

//         } catch (error) {
//             console.error(error);
//         }
//     }
// }
